// Lightweight Google Analytics 4 helper.
// Loads gtag asynchronously only when a real Measurement ID is configured.
//
// Configure via either:
//   1. Frontend env var REACT_APP_GA_MEASUREMENT_ID (preferred for Netlify)
//   2. Hardcoded fallback below
//
// Leave as "G-XXXXXXXXXX" to disable analytics (loader will skip).

const FALLBACK_ID = "G-XXXXXXXXXX";

function getId() {
    const envId =
        (typeof process !== "undefined" &&
            process.env &&
            process.env.REACT_APP_GA_MEASUREMENT_ID) ||
        FALLBACK_ID;
    return envId && envId !== "G-XXXXXXXXXX" ? envId : null;
}

let initialised = false;

export function initAnalytics() {
    if (initialised || typeof window === "undefined") return;
    const id = getId();
    if (!id) return;

    initialised = true;

    // Inject gtag script
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(s);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
        window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag("js", new Date());
    // anonymize_ip for privacy-friendly default
    gtag("config", id, {
        anonymize_ip: true,
        send_page_view: false, // we'll fire pageviews on SPA route changes
    });
}

export function trackPageview(path, title) {
    if (typeof window === "undefined" || !window.gtag) return;
    const id = getId();
    if (!id) return;
    window.gtag("event", "page_view", {
        page_path: path,
        page_title: title || document.title,
        page_location: window.location.href,
    });
}

export function trackEvent(name, params = {}) {
    if (typeof window === "undefined" || !window.gtag) return;
    window.gtag("event", name, params);
}
